import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import {baseUrl} from '../Univ.js'
function DueEntry(props) {
    const [inputValue, setInputValue] = useState('');
    const [patients, setPatients] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [searchClicked, setSearchClicked] = useState(false);
    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    }
    useEffect(() => {
        if (searchClicked) {
            fetchData();
        }
    }, [searchClicked]);
    function fetchData() {
        setIsLoading(true);
        axios.get(baseUrl + `pat-search/?search=${searchTerm}`)
            .then(response => {
                setPatients(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    function handleSearchButtonClick() {
        setSearchClicked(true);
    }
    function handleSearchInputChange(event) {
        setSearchTerm(event.target.value);
    }
    const columns = [
        {field: 'id', headerName: 'Id'},
        {
            field: 'pat_id', headerName: 'Patient ID',
            renderCell: (params) => (
                <Link to={`/due-details/${params.value}`}>
                    {params.value}
                </Link>
            )
        },
        {field: 'patient', headerName: 'Patient'},
        {field: 'gender', headerName: 'Gender'},
        {field: 'age', headerName: 'Age'},
        {field: 'address1', headerName: 'Address'},
        {field: 'mobile', headerName: 'mobile'},
    ];
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        <label className="col-sm-3 col-lg-2 control-label">Search Patient</label>
                        <div className="col-sm-9 col-lg-10 controls">
                            <input className="form-control" type="headerName"
                                   placeholder="pat id, address, name, mobile"
                                   value={searchTerm} onChange={handleSearchInputChange}/>
                            <button className="btn btn-primary" onClick={() => fetchData()}>Search</button>
                        </div>
                    </div>
                </div>

                {!isLoading && patients.length > 0 ? (
                    <div style={{height: '100%', width: '100%'}} className="mt-5">
                        <DataGrid
                            sx={{
                                boxShadow: 4,
                                border: 4,
                                borderColor: 'primary.light',
                                '& .MuiDataGrid-cell:hover': {
                                    color: 'primary.main',
                                },
                            }}
                            rows={patients}
                            columns={columns}
                            pageSize={10}
                            slots={{toolbar: GridToolbar}}
                            autoHeight
                        />
                    </div>
                ) : (
                    <></>
                )}

            </div>
        </section>
    )
}
export default DueEntry;